<template>
  <div class='resource-type-container'>
    <div class="resource-type-container__text">
      {{ getResourceType }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResourceTypeTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getResourceType() {
      return this.item.resourceType;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-type-container {
  display: flex;
  align-items: center;
  &__text{
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-semibold;
    line-height: 1.3em;
    width: 100%;
    padding-right: rem(10);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
  }
}
</style>
